"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const data_field_1 = require("../data-field");
const core_decorators_1 = require("core-decorators");
const data_1 = require("../../data/data");
const errors_1 = require("../../errors");
const debug_risk_1 = require("../../../debug/debug-risk");
let Covariate = class Covariate extends data_field_1.DataField {
    constructor(covariateJson, customFunction, derivedField) {
        super(covariateJson);
        this.beta = covariateJson.beta;
        this.groups = covariateJson.groups;
        this.referencePoint = covariateJson.referencePoint;
        this.customFunction = customFunction;
        this.derivedField = derivedField;
    }
    getComponent(data, userFunctions, tables) {
        const coefficient = this.calculateCoefficient(data, userFunctions, tables);
        const component = this.calculateComponent(coefficient);
        debug_risk_1.debugRisk.addCovariateDebugInfo(this.name, {
            coefficient,
            component,
            beta: this.beta,
        });
        return component;
    }
    calculateCoefficient(data, userDefinedFunctions, tables) {
        let coefficent = 0;
        try {
            coefficent = data_1.findDatumWithName(this.name, data).coefficent;
        }
        catch (err) {
            if (err instanceof errors_1.NoDatumFoundError) {
                if (this.customFunction) {
                    coefficent = this.customFunction.calculateCoefficient(data);
                }
                else if (this.derivedField) {
                    coefficent = this.derivedField.calculateCoefficent(data, userDefinedFunctions, tables);
                }
            }
            else {
                throw err;
            }
        }
        const formattedCoefficent = this.formatCoefficentForComponent(coefficent);
        if (formattedCoefficent === undefined) {
            throw new Error(`No coefficient found for covariate ${this.name}`);
        }
        return formattedCoefficent;
    }
    calculateDataToCalculateCoefficent(data, userDefinedFunctions, tables) {
        // Try to find a datum with the same name field in the data arg
        const datumFound = this.getDatumForField(data);
        /* If we did not find anything then we need to calculate the coefficent
        using either a custom function or the coresponding derived field */
        if (!datumFound) {
            if (this.customFunction) {
                return this.customFunction.calculateDataToCalculateCoefficent(data, userDefinedFunctions, tables);
            }
            else if (this.derivedField) {
                // Custom function has higher priority
                // Fall back to derived field
                try {
                    return this.derivedField.calculateDataToCalculateCoefficent(data, userDefinedFunctions, tables);
                }
                catch (err) {
                    return [];
                }
            }
            else {
                return [];
            }
        }
        else {
            // If the data for this covariate coefficient's calculations already exists in the data arg we don't need to return anything
            return [datumFound];
        }
    }
    /**
     * Returns all the fields which are part of this Covariate's dependency
     * tree. **Does not return the covariate itself**.
     *
     * @returns {DataField[]}
     * @memberof Covariate
     */
    getDescendantFields() {
        return this.derivedField
            ? this.derivedField.getDescendantFields()
            : this.customFunction
                ? this.customFunction.firstVariableCovariate
                    .getDescendantFields()
                    .concat(this.customFunction.firstVariableCovariate)
                : [];
    }
    isPartOfGroup(group) {
        return this.groups.indexOf(group) !== -1;
    }
    calculateComponent(coefficent) {
        const component = coefficent * this.beta;
        return component;
    }
    formatCoefficentForComponent(coefficent) {
        if (coefficent === null ||
            coefficent === undefined ||
            coefficent === 'NA' ||
            isNaN(coefficent)) {
            debug_risk_1.debugRisk.addCovariateDebugInfo(this.name, {
                setToReference: true,
            });
            return this.referencePoint;
        }
        else {
            return this.formatCoefficient(coefficent);
        }
    }
};
Covariate = tslib_1.__decorate([
    core_decorators_1.autobind,
    tslib_1.__metadata("design:paramtypes", [Object, Object, Object])
], Covariate);
exports.Covariate = Covariate;
//# sourceMappingURL=covariate.js.map